import { render, staticRenderFns } from "./Csvfileupload.vue?vue&type=template&id=588d70e6&"
import script from "./Csvfileupload.vue?vue&type=script&lang=js&"
export * from "./Csvfileupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports